import React, { useState, useEffect, useContext } from 'react';
import * as fkn from "../lib/fkn";
import SDOContext from '../sdo.js'
import {Route, Routes} from "react-router-dom";
//import ADOContext from "../ado";

import Pos_Home from './pos/home.js';
import Pos_Period from './pos/period.js';
import Pos_Dr from './pos/dr.js';
import Pos_Konto from './pos/konto.js';
import Pos_Trs from './pos/trs.js';
import Pos_Hotel from './pos/hotel.js';
import Pos_CC from './pos/cc.js';
import Pos_Kassa from './pos/kassa.js';
import {withRouter} from "../lib/react/withRouter";
import Pms_Home from "./pms/home";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Red_Pos extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
      var po = {};
      po.period = { "fid": "f06", "url": "/red/pos/period", "name": "Period", "active": false };
      po.dr = { "fid": "f06", "url": "/red/pos/dr", "name": "Dagrapport", "active": false };
      po.konto = { "fid": "f06", "url": "/red/pos/konto", "name": "Konto", "active": false };
      po.trs = { "fid": "f06", "url": "/red/pos/trs", "name": "Transaktioner", "active": false };
      po.hotel = { "fid": "f06", "url": "/red/pos/hotel", "name": "Hotell", "active": false };
      po.cc = { "fid": "f06", "url": "/red/pos/cc", "name": "Kort", "active": false };
      po.kassa = { "fid": "f06", "url": "/red/pos/kassa", "name": "Kassa", "active": false };
      this.state.po = po;
      this.state.pa = [];
      this.state.pa = Object.values(po);
  }
    fknGo(row) {
        sso.seo.sfkn = row;
        this.props.navigate(row.url);
    }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {
    return (
        <div className="web-app">
            { this.props.store.cfg.bread ?
                <div className="web-bread">
                    <div className="breadcrumb">
                        { this.state.pa.map((row, key) =>
                            <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
                        )}
                        <div className="flex"></div>
                        <div className="cdigreen">{ sso.seo.sfkn ? sso.seo.sfkn.name : null }</div>
                    </div>
                </div>
                : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="period" element={ <Pos_Period store={this.webStore} />} />
            <Route path="dr" element={ <Pos_Dr store={this.webStore} />} />
            <Route path="konto" element={ <Pos_Konto store={this.webStore} />} />
            <Route path="trs" element={ <Pos_Trs store={this.webStore} />} />
            <Route path="hotel" element={ <Pos_Hotel store={this.webStore} />} />
            <Route path="cc" element={ <Pos_CC store={this.webStore} />} />
            <Route path="kassa" element={ <Pos_Kassa store={this.webStore} />} />
            <Route path="*" element={ <Pos_Home store={this.webStore} />} />
        </Routes>
    </div>

  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Red_Pos);
